import { Component, OnDestroy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthService } from './services/auth.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnDestroy {
  title = 'Caribbean_Auto_Terminal_Frontend';

  constructor(private authService: AuthService) {
    if (this.authService.isLoggedIn()) {
      this.authService.startTokenExpirationCheck();
    }
  }
  ngOnDestroy(): void {
    this.authService.stopTokenExpirationCheck();
  }
}
